export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      locationActiveInfo: {
        yearMonth: "2021年03月",
        dailyActiveInfo: [
          {
            activedate: "2021年03月01日",
            activeCount: 15
          }
        ]
      }
    }
  }
}